import { createUUID } from '../../../common/services/uuid.service'

class TextTableService {
  transformBlockDataToLayout (table) {
    return {
      header: table.header.map((cell) => {
        return { key: createUUID(), ...cell }
      }),
      data: table.data.map((row) => {
        return {
          key: createUUID(),
          row: row.map((cell) => {
            return { key: createUUID(), ...cell }
          })
        }
      })
    }
  }

  initializeHeader () {
    return [this.generateEmptyCell(false), this.generateEmptyCell(false), this.generateEmptyCell(false)]
  }

  initializeDataRows () {
    return [
      [this.generateEmptyCell(false), this.generateEmptyCell(false), this.generateEmptyCell(false)],
      [this.generateEmptyCell(false), this.generateEmptyCell(false), this.generateEmptyCell(false)]
    ]
  }

  generateEmptyRowWithKeys (table) {
    return {
      key: createUUID(),
      row: this.generateEmptyRow(table, true)
    }
  }

  generateEmptyRow (table, includeKey) {
    return table.header.map(() => (this.generateEmptyCell(includeKey)))
  }

  generateEmptyCell (includeKey = false) {
    const cell = { delta: '' }
    if (includeKey) {
      cell.key = createUUID()
    }
    return cell
  }

  getDataCellLocation (table, key) {
    let location = {}
    table.data.forEach(({ row }, rowIndex) => {
      const colIndex = row.findIndex((cell) => (cell.key === key))
      const isFound = colIndex !== -1
      if (isFound) {
        location.row = rowIndex
        location.column = colIndex
      }
    })
    return location
  }

  getHeaderCellLocation (table, key) {
    return table.header.findIndex((cell) => (cell.key === key))
  }
}

export const textTableService = new TextTableService()
